/**
 * Gestion des messages FR de la gestion des crédits
 */

module.exports = {

    credits: 'credit | credit | credits',
    counter: '<span class="counter">0</span> credit | <span class="counter">1</span> credit | <span class="counter">{ count }</span> credits',
    from: 'Starting from',

    taskConfigurations: {
        groups: {
            button: {
                label: 'Manage configuration groups'
            }
        },
        title: 'Cost per task',
        fields: {
            task: 'Task',
            credits: 'Credits'
        }
    },

    purchase: {
        title: 'Subscriptions and credits',
        description: 'Add or change your subscription / Your credits',

        monthly: {
            metaTitle: 'Subscriptions - Sign up',
            tabLabel: 'Subscription',
            paymentFrequency: {
                monthly: 'Monthly',
                yearly: 'Yearly'
            },
            product: {
                credits: '0 credit | 1 credit | { count } credits',
                subscribeButton: {
                    label: 'Subscribe'
                },
                unsubscribeButton: {
                    label: 'Unsubscribe'
                },
                affiliationCode: {
                    label: 'Affiliate code'
                }
            },

            unsubscribeModal: {
                title: 'Unsubscribe',
                description: 'Why do you want to stop your subscription?',
                form: {
                    error: 'An error occurred while unsubscribing.',
                    fields: {
                        otherReason: 'Specify the reason'
                    },
                    button: {
                       submit: {
                           label: 'Unsubscribe'
                       }
                    }
                }
            },

            selectConserveNetworksModal: {
                title: 'Network to be preserved | Network to be preserved | Networks to be preserved',
                form: {
                    error: 'An error occurred during recording.'
                }
            },

            endedAt: 'Subscription ends on { date }.'
        },

        unique: {
            metaTitle: 'Credits',
            tabLabel: 'Credits'
        },

        loading: {
            error: {
                countries: 'An error occurred during data loading.',
                taskConfiguration: 'An error occurred during data loading.',
                creditPacks: 'An error occurred while loading the product list.',
                currentSubscription: 'An error occurred while loading your subscription.',
                cart: 'An error occurred during shopping basket initialization.',
                empty: 'No products were found.'
            }
        },

        cart: {
            title: 'My shopping basket',
            amountWithoutTax: 'Sub-total excl.',
            tax: 'VAT ({ percent }%)',
            amountWithTax: 'Total incl. VAT',
            reductionWithoutTax: 'Reduction excluding VAT'
        },

        payment: {
            title: 'Payment',
            methods: {
                creditCard: 'Credit card',
                sepa: 'SEPA Credit Transfer',
            },
            error: 'An error occurred during the payment process.',
            fields: {
                method: 'Method of payment',
                creditCard: {
                    ownerName: 'Cardholder\'s name',
                    number: 'Card number',
                    expiry: 'Expiry date',
                    cvc: 'Validation code (CVC)'
                },
                sepa: {
                    ownerName: 'Cardholder\'s name',
                    email: 'E-mail adress',
                    iban: 'IBAN'
                }
            },
            fieldset: {
                society: 'Billing information'
            },
            validation: {
                owner: {
                    required: 'The name is required.',
                    min: 'The name must have at least { min } characters.',
                    max: 'The name must have { max } characters maximum.'
                },
                email: {
                    email: 'The email address is incorrect.'
                }
            },
            waitingValidation: 'Your payment is awaiting validation, you will be notified when it has been validated.',
            cvc: {
                altLabel: 'Click to learn more about the credit card validation code.'
            },
            sepa: {
                disclaimer: 'By providing your IBAN and confirming this payment, you authorize { applicationName } to send instructions to your bank to debit your credit card.'
            },
            submit: {
                label: 'Confirm my order'
            }
        }

    },

    paymentInformations: {
        form: {
            error: 'An error occurred while processing your payment informations.'
        }
    }

};
